import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

type GetDecryptedCookieValueOptions = {
  removeOnError?: boolean;
};

export const getDecryptedCookieValue = (
  cookieName: string,
  { removeOnError = false }: GetDecryptedCookieValueOptions = {}
): string | null => {
  const encryptedValue = Cookies.get(cookieName);

  if (!encryptedValue) {
    return null;
  }

  try {
    const value = CryptoJS.AES.decrypt(encryptedValue, import.meta.env.VITE_SECRET_KEY).toString(
      CryptoJS.enc.Utf8
    );

    return value || null;
  } catch {
    if (removeOnError) {
      Cookies.remove(cookieName);
    }

    return null;
  }
};

export const encryptCookieValue = (cookieName: string, value: string) => {
  try {
    const encriptedValue = CryptoJS.AES.encrypt(value, import.meta.env.VITE_SECRET_KEY).toString();
    Cookies.set(cookieName, encriptedValue, { expires: 7 });
  } catch {
    Cookies.remove(cookieName);
  }
};
